import WordList from "./WordList";
import "./WordBin.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

function WordBin(props) {
  return (
    <Col>
      <Row>
        <h1>Word Bin</h1>
      </Row>
      {props.words.map((word) => (
        <WordList
          key={word.id}
          id={word.id}
          name={word.name}
          group={word.group}
          width={"400px"}
          height={'75px'}
          margin={"1.25rem"}
          dragType={"word"}
        />
      ))}
    </Col>
  );
}
export default WordBin;
